// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transition-property-max-height[data-v-90e3b5b2]{transition-property:max-height}.hover-opacity[data-v-90e3b5b2]{transition-duration:.15s}.hover-opacity[data-v-90e3b5b2]:hover{opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
